/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"wrapper_GK+Hx","blockSolution":"blockSolution_9s5YW"};